import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a26ceca0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26ceca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a26ceca0')) {
      api.createRecord('a26ceca0', component.options)
    } else {
      api.reload('a26ceca0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a26ceca0&scoped=true", function () {
      api.rerender('a26ceca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/systemForm/index.vue"
export default component.exports